import {FormikConfig} from 'formik';
import _ from 'lodash';

import utils from '@utils';

export const create: Pick<FormikConfig<any>, 'validate'>['validate'] = (
  values: any
) => {
  const errors: any = {};

  if (!values.lastName) {
    errors.lastName = '姓は必須入力です';
  }
  if (!values.firstName) {
    errors.firstName = '名は必須入力です';
  }
  if (!values.lastKana) {
    errors.lastKana = 'セイは必須入力です';
  }
  if (!values.firstKana) {
    errors.firstKana = 'メイは必須入力です';
  }

  if (_.isNull(values.prefecture)) {
    errors.prefecture = '地域は必須入力です';
  }
  if (_.isNull(values.authLevel)) {
    errors.authLevel = '権限は必須入力です';
  }
  utils.validate.birthdate(errors, values, {
    year: 'birthyear',
    month: 'birthmonth',
    day: 'birthday',
  });
  utils.validate.email(errors, values);
  utils.validate.phoneNumber(errors, values);
  utils.validate.kana(errors, values, {
    key: 'firstKana',
    require: true,
    label: 'セイ',
  });
  utils.validate.kana(errors, values, {
    key: 'lastKana',
    require: true,
    label: 'メイ',
  });

  return errors;
};

export const update: Pick<FormikConfig<any>, 'validate'>['validate'] = (
  values: any
) => {
  const errors: any = {};

  if (!values.lastName) {
    errors.lastName = '姓は必須入力です';
  }
  if (!values.firstName) {
    errors.firstName = '名は必須入力です';
  }
  if (!values.lastKana) {
    errors.lastKana = 'セイは必須入力です';
  }
  if (!values.firstKana) {
    errors.firstKana = 'メイは必須入力です';
  }
  if (_.isNull(values.prefecture)) {
    errors.prefecture = '地域は必須入力です';
  }
  utils.validate.birthdate(errors, values, {
    year: 'birthyear',
    month: 'birthmonth',
    day: 'birthday',
  });
  utils.validate.email(errors, values);
  utils.validate.phoneNumber(errors, values);
  utils.validate.kana(errors, values, {
    key: 'firstKana',
    require: true,
    label: 'セイ',
  });
  utils.validate.kana(errors, values, {
    key: 'lastKana',
    require: true,
    label: 'メイ',
  });
  return errors;
};

export const changePassword: Pick<FormikConfig<any>, 'validate'>['validate'] = (
  values: any
) => {
  const errors: any = {};

  utils.validate.password(errors, values, {
    key: 'currentPassword',
    require: true,
    label: '現在のパスワード',
  });
  utils.validate.password(errors, values, {
    key: 'password',
    require: true,
    label: 'パスワード',
  });
  utils.validate.password(errors, values, {
    key: 'confirmPassword',
    require: true,
    label: 'パスワード（確認用）',
  });
  if (values.password !== values.confirmPassword) {
    errors.confirmPassword = 'パスワードとパスワード (確認用) に違いがあります';
  }
  return errors;
};
export const resetInitialPassword: Pick<
  FormikConfig<any>,
  'validate'
>['validate'] = (values: any) => {
  const errors: any = {};
  utils.validate.password(errors, values, {
    key: 'password',
    require: true,
    label: '新しいパスワード',
  });
  utils.validate.password(errors, values, {
    key: 'confirmPassword',
    require: true,
    label: '新しいパスワード（確認用）',
  });
  if (values.password !== values.confirmPassword) {
    errors.confirmPassword =
      '新しいパスワードと新しいパスワード (確認用) に違いがあります';
  }
  return errors;
};

export const updateAuthority: Pick<
  FormikConfig<any>,
  'validate'
>['validate'] = (values: any) => {
  const errors: any = {};

  utils.validate.email(errors, values);

  utils.validate.password(errors, values, {
    key: 'password',
    require: true,
    label: 'パスワード',
  });
  utils.validate.password(errors, values, {
    key: 'confirmPassword',
    require: true,
    label: 'パスワード（確認用）',
  });
  if (values.password !== values.confirmPassword) {
    errors.confirmPassword = 'パスワードとパスワード (確認用) に違いがあります';
  }
  return errors;
};

export const resetPassword: Pick<FormikConfig<any>, 'validate'>['validate'] = (
  values: any
) => {
  const errors: any = {};

  if (!values.code) {
    errors.code = '認証コードは必須入力です';
  }
  if (values.code.length && values.code.length !== 6) {
    errors.code = '認証コードは6桁で入力してください';
  }
  if (!/^[0-9]+$/.test(values.code) && values.code.length) {
    errors.code = '認証コードは数字のみで入力してください';
  }

  utils.validate.password(errors, values, {
    key: 'newPassword',
    require: true,
    label: 'パスワード',
  });
  utils.validate.password(errors, values, {
    key: 'confirmNewPassword',
    require: true,
    label: 'パスワード（確認用）',
  });
  if (values.newPassword !== values.confirmNewPassword) {
    errors.confirmNewPassword =
      'パスワードとパスワード (確認用) に違いがあります';
  }

  return errors;
};

export const resetPasswordMain: Pick<
  FormikConfig<any>,
  'validate'
>['validate'] = (values: any) => {
  const errors: any = {};

  utils.validate.email(errors, values);

  return errors;
};
